module.exports = __webpack_public_path__ + "static/media/boarding-game.6aa1c01e.png";